import { render } from "./ImagePreviewDialog.vue?vue&type=template&id=4708a08e&scoped=true&ts=true"
import script from "./ImagePreviewDialog.vue?vue&type=script&lang=ts"
export * from "./ImagePreviewDialog.vue?vue&type=script&lang=ts"

import "./ImagePreviewDialog.vue?vue&type=style&index=0&id=4708a08e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4708a08e"]])

export default __exports__